// extracted by mini-css-extract-plugin
export default {"no-color":"P5obRkWTfKWARRAkY5kS","disabled":"L8AO1NUamxl4qQWKUnL0"};